import { render, staticRenderFns } from "./BankTrial.vue?vue&type=template&id=698572c6&scoped=true&"
import script from "./BankTrial.vue?vue&type=script&lang=js&"
export * from "./BankTrial.vue?vue&type=script&lang=js&"
import style0 from "./BankTrial.vue?vue&type=style&index=0&id=698572c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698572c6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle})
